var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"the-personal-icon",class:[("icon-" + _vm.name)],attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":_vm.getIconUrl,"xmlns:xlink":"http://www.w3.org/1999/xlink"}})])}
var staticRenderFns = []

export { render, staticRenderFns }